import { render, staticRenderFns } from "./GlobalShockCountdown.vue?vue&type=template&id=64049b61&scoped=true&"
import script from "./GlobalShockCountdown.vue?vue&type=script&lang=js&"
export * from "./GlobalShockCountdown.vue?vue&type=script&lang=js&"
import style0 from "./GlobalShockCountdown.vue?vue&type=style&index=0&id=64049b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64049b61",
  null
  
)

export default component.exports